import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import $ from "jquery";
import React, { useEffect, useRef } from "react";

const TablaBuscarPromociones = ({ datos }) => {
    const tableRef = useRef();

    const tipoBadgeClasses = {
        Total: "badge-primary",    // azul
        Unico: "badge-success",    // verde
        Combo: "badge-warning",    // amarillo
        Evento: "badge-info",      // celeste
    };

    const estadoBadgeClasses = {
        Activo: "badge-success",   // verde
        Inactivo: "badge-secondary", // gris
        Agotado: "badge-danger",   // rojo
    };

    const formatearFecha = (fechaIso) => {
        if (!fechaIso) return "";
        const d = new Date(fechaIso);
        return d.toLocaleDateString("es-ES", { year: "numeric", month: "2-digit", day: "2-digit" });
    };

    const formatearDiasSemana = (diasStr) => {
        if (!diasStr) return "";
        return diasStr
            .split(",")
            .map(dia => dia.charAt(0).toUpperCase() + dia.slice(1).toLowerCase())
            .join(", ");
    };

    useEffect(() => {
        if (datos.length === 0) return;
        $(tableRef.current).DataTable({
            data: datos,
            columns: [
                { title: "ID", data: "id" },
                {
                    title: "Nombre y Descripción",
                    data: null,
                    render: (data, type, row) => `${row.nombre}<br/><small>${row.descripcion}</small>`
                },
                {
                    title: "Tipo", data: "tipo",
                    render: data => {
                        const clase = tipoBadgeClasses[data] || "badge-light";
                        return `<span class="badge ${clase}">${data}</span>`;
                    }
                },
                {
                    title: "Estado", data: "estado",
                    render: data => {
                        const clase = estadoBadgeClasses[data] || "badge-light";
                        return `<span class="badge ${clase}">${data}</span>`;
                    }
                },
                {
                    title: "Fechas",
                    data: null,
                    render: (data, type, row) => `
                        <div>
                            <strong>Inicio:</strong> ${formatearFecha(row.fechaInicio)}<br/>
                            <strong>Fin:</strong> ${formatearFecha(row.fechaFin)}
                        </div>
                    `
                },
                {
                    title: "Horas",
                    data: null,
                    render: (data, type, row) => `
                            <div>
                                <strong>Inicio:</strong> ${row.hora_inicio}<br/>
                                <strong>Fin:</strong> ${row.hora_fin}
                            </div>
                        `
                },
                {
                    title: "Días Semana", data: "diasSemana",
                    render: data => formatearDiasSemana(data)
                },
                {
                    title: "Descuento", data: "descuento",
                    render: data => `<span class="badge badge-warning">${data}</span>`
                },
                { title: "Descuento Total (L)", data: "descuentoTotal" },
                { title: "Límite Total", data: "limite_total" },
                { title: "Límite por Cliente", data: "limite_cliente" },
            ],
            paging: true,
            lengthChange: true,
            ordering: true,
            info: true,
            autoWidth: true,
            responsive: true,
            dom: "<'row'<'col-sm-12 col-md-6'B><'col-sm-12 col-md-6'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
            buttons: ["copy", "csv", "excel", "pdf", "print"],
            language: {
                decimal: "",
                emptyTable: "No hay información",
                info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
                infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
                infoFiltered: "(Filtrado de _MAX_ total entradas)",
                lengthMenu: "Mostrar _MENU_ Entradas",
                loadingRecords: "Cargando...",
                processing: "Procesando...",
                search: "Buscar:",
                zeroRecords: "Sin resultados encontrados",
                paginate: { first: "|<<", last: ">>|", next: ">>", previous: "<<" },
            },
            destroy: true,
        });
    }, [datos]);

    return (
        <div className="table-responsive">
            <table
                ref={tableRef}
                id="promociones"
                className="table table-bordered table-hover nowrap"
                style={{ width: "100%" }}
            />
        </div>
    );
};

export default TablaBuscarPromociones;